import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type LoadingSpinnerProps = {
  loadingText?: string;
};

export default function LoadingSpinner({ loadingText }: LoadingSpinnerProps) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        position: 'absolute',
        height: '100%',
        width: '100%',
        top: 0,
        left: 0,
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: 2,
        zIndex: 1001,
      }}
    >
      <CircularProgress color="secondary" />
      <Typography>{loadingText || t('loadingSpinner.text')}</Typography>
    </Box>
  );
}
